import { render, staticRenderFns } from "./apprHistoryPop.vue?vue&type=template&id=2572012c"
import script from "./apprHistoryPop.vue?vue&type=script&lang=js"
export * from "./apprHistoryPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2572012c')) {
      api.createRecord('2572012c', component.options)
    } else {
      api.reload('2572012c', component.options)
    }
    module.hot.accept("./apprHistoryPop.vue?vue&type=template&id=2572012c", function () {
      api.rerender('2572012c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/appr/apprHistoryPop.vue"
export default component.exports